import { action, computed } from 'mobx'
import { type CallCenterSearchResult } from './call-center-search-result'

/**
 * A customer lookup result.
 */
export class CallCenterSearchResultItemViewModel {
  constructor(
    readonly result: CallCenterSearchResult,
    private readonly _isSelected: (result: CallCenterSearchResult) => boolean,
    private readonly _select: (result: CallCenterSearchResult) => void,
  ) {}

  /**
   * The workspace member that describes the client when there is no HubSpot
   * contact.
   */
  @computed
  private get _primaryMember() {
    return this.result.workspaceMembers[0]?.member
  }

  @computed
  get displayName() {
    const contact = this.result.hubspotContact
    return contact
      ? [contact.firstName, contact.lastName].filter(Boolean).join(' ')
      : this._primaryMember?.displayName || 'Unknown client'
  }

  @computed
  get email() {
    return this.result.hubspotContact?.email || this._primaryMember?.email || ''
  }

  @computed
  get phoneNumber() {
    return this.result.hubspotContact?.phone || this._primaryMember?.phone || ''
  }

  @computed
  get isSelected() {
    return this._isSelected(this.result)
  }

  @action.bound
  select() {
    this._select(this.result)
  }
}
